import { useEffect } from "react";
import { useAppSelector } from "./redux";
import { IAnalyticsController } from "../hexagon/adapters/driver/analyticsController";
import { screenTimeEvent } from "../constants/screenTimeEvent";
import { useResolveToBasePath } from "./useResolveToBasePath";

interface IUseScreenTimeMetrics {
  analyticsController: IAnalyticsController;
}

export const useScreenTimeMetrics = ({
  analyticsController,
}: IUseScreenTimeMetrics) => {
  const { user, userClinic } = useAppSelector((state) => ({
    user: state.auth.user,
    userClinic: state.clinic.userClinic,
  }));

  const route = useResolveToBasePath();

  useEffect(() => {
    if (screenTimeEvent[route]) {
      analyticsController.timeEvent("Screen Time");
      return () => {
        analyticsController.logEvent("Screen Time", {
          screen: screenTimeEvent[route],
          email: user?.email,
          selectedFacility: userClinic?.name,
          selectedFacilityId: userClinic?.id,
          cUserId: user?.userID,
        });
      };
    }
  }, [route]);
};
